module.exports = __webpack_public_path__ + "static/media/fingerprint.f29ec8c9.png";